// export const apiUrl = 'http://local.host', devMode = true;
export const apiUrl = 'http://api.lucia-rapetti.com', devMode = false;


// WEBPACK FOOTER //
// ./src/lib/constants.js